const getFetch = async (type, section = "", limit = "", offset = '',typesOr = '', date = '') => {
  let dataObject = {};
  try {
    const response = await fetch(
      `${process.env.LILAX_FRONTEND_API}latest/?type=${type}${typesOr}${section}${date}${limit}${offset}`
    );
    if (!response.ok) {
      dataObject.code = response.status;
      dataObject.message = response.statusText;
      throw new Error(`getLatest: ${response.status} ${response.statusText}`);
    }
    const data = await response.json();
    const { items = [], total = null } = data;
    dataObject.code = response.status;
    dataObject.data = Array.isArray(items) && items.length > 0 ? items : [];
    dataObject.count = total;
  } catch (error) {
    dataObject.code = "code" in dataObject ? dataObject.code : 500;
    dataObject.message =
      "message" in dataObject ? dataObject.message : "Internal server error";
  }
  return dataObject;
};

export const getLatest = async (type, section, limit, offset, typesOr, date ) => {
  let paramSection = section ? `&section=${section}` : "";
  let paramLimit = limit ? `&limit=${limit}` : "";
  let paramtypesOr = typesOr ? `&typesOr=${typesOr}` : "";
  let paramdate = date ? `&date=${date}` : "";
  const paramOffset = offset ? `&offset=${offset}` : "";
  if (!type) return [];
  const { data = [], code, count = null } = await getFetch(type, paramSection, paramLimit, paramOffset,paramtypesOr, paramdate);
  return { data , code, count };
};

export const getLatestByUrl = async (type, section = '', limit = '', offset = '', typesOr = '' ) => {
  let paramSection = section ? `&sectionUrl=${section}` : "";
  let paramLimit = limit ? `&limit=${limit}` : "";
  let paramtypesOr = typesOr ? `&typesOr=${typesOr}` : "";
  const paramOffset = offset ? `&offset=${offset}` : "";
  if (!type) return [];
  const { data = [], code, count = null } = await getFetch(type, paramSection, paramLimit, paramOffset,paramtypesOr);
  return { data , code, count };
};

export const getLastCover = async (fecha = '') => {

  let param = fecha;
  if (param === '') {
      const date = new Date();
      const year = date.getFullYear();
      const month = ((date.getMonth() + 1).toString().length < 2) ? `0${(date.getMonth() + 1).toString()}` : `${(date.getMonth() + 1).toString()}`;
      const day = (date.getDate().toString().length < 2) ? `0${date.getDate().toString()}` : `${date.getDate().toString()}`;
      param = `${year}${month}${day}`;
  }

  let dataObject = {};
  try {
      const response = await fetch(`${process.env.LILAX_FRONTEND_API}detail/${param}?type=frontpage&field=date`);
      if (!response.ok) {
          dataObject.code = response.status;
          dataObject.message = response.statusText;
          throw new Error(`getLastCover: ${response.status} ${response.statusText}`);
      }
      const data = await response.json();
      const { clippings = [] } = data.item;
      dataObject.code = response.status;
      dataObject.data = (Array.isArray(clippings) && clippings.length > 0) ? clippings : [];
  } catch (error) {
      dataObject.code = ("code" in dataObject) ? dataObject.code : 500;
      dataObject.message = ("message" in dataObject) ? dataObject.message : 'Internal server error';
  }
  return dataObject;
}

export const getMaMWorldCupData = async (idOptaMundial) => {
  const timeout = 10000;
  const apiHandlerUrl = process.env.API_HANDLER_BACKEND_URL;

  try {
    //fetch con signal para abortar la solicitud si tarda mucho
    const controller = new AbortController();
    const signal = controller.signal;
    const timeoutId = setTimeout(() => controller.abort(), timeout);

    const url = `${apiHandlerUrl}/api/opta/futbol/current-stage/${idOptaMundial}?apikey=clarin`;
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Accept-encoding": "gzip",
      },
      signal,
    });
    clearTimeout(timeoutId); // Limpiar el timeout si la solicitud se completó
    const result = await response.json();
    return {
      code: result.code,
      data: result.data,
      redis: result.redis,
      error: result.error,
    };
  } catch (error) {
    console.error(error);
    if (error.name === "AbortError") {
      return {
        code: 408,
        data: null,
        error: `timeout of ${timeout}ms exceeded`,
      };
    }
    return {
      code: 500,
      data: null,
      error: "something went wrong",
    };
  }
}
